<template>
    <v-row align="center"
           justify="space-between"
           class="mx-2 mt-2 flex-wrap"
           style="position: relative;
                  width: 95%;
                  z-index: 1;"
           :style="{ top: menuLocation === 'toolbar' ? '0' : '125px', marginBottom: menuLocation === 'toolbar' ? '0' : '135px' }">
        <v-col cols="12"
               sm="6"
               md="4"
               lg="3"
               v-for="(card, index) in cards"
               :key="index">
            <slot name="connections-cards" :card="card"/>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      menuLocation: state => state.graphicAspect.menuLocation
    })
  },
  props: {
    cards: {
      type: Array
    }
  }
}
</script>
